module.exports = __webpack_public_path__ + "img/x.3eb7352c.svg";